import React, { Component } from 'react';
import style from './style.css';
import CSSModules from 'react-css-modules';

const ClassAD = ({
    image,
    title,
    description,
    className,
}) => {

    return (
        <div styleName="block" className={className}>
            <img src={image} alt={title} />
            <h3 styleName="title">{ title }</h3>
            <p>{ description }</p>
        </div>
    );
}

export default CSSModules(ClassAD,style,{allowMultiple:true});


/** WEBPACK FOOTER **
 ** ./src/component/classAD/index.js
 **/